<template>
    <div>
        <header-portrate v-if="showHeader" />
        <TabsComp v-if="showHeader && $route.path === '/ecar'" :tabs="[]" />
        <b-container fluid class="new-dashboard py-3">
            <b-row>
                <b-col cols="12">
                    <v-card class="filter-card" outlined>
                        <v-card-text class="pb-2">
                            <b-row v-if="showBranchButtons" class="mb-2">
								<b-col cols="12" class="text-center">
									<div class="branch-buttons-wrap">
										<button
											v-for="(branch, index) in branchOptions"
											:key="branch.id"
											type="button"
											class="branch-btn"
											:class="[
												`branch-btn--c${index % 6}`,
												{ 'branch-btn--active': filters.branches.includes(branch.id) }
											]"
											@click="toggleBranch(branch.id)"
										>
											<v-icon small class="mr-1">
												{{ filters.branches.includes(branch.id) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
											</v-icon>
											{{ branch.name }}
										</button>
									</div>
								</b-col>
							</b-row>

                            <b-row class="align-items-end">
                                <b-col cols="12" md="4">
                                    <v-menu
                                        v-model="startMenu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="filters.startDate"
                                                :label="lang.nd_start_date"
                                                prepend-inner-icon="mdi-calendar"
                                                outlined
                                                dense
                                                readonly
                                                hide-details
                                                v-bind="attrs"
                                                v-on="on"
                                            />
                                        </template>
                                        <v-date-picker
                                            v-model="filters.startDate"
                                            no-title
                                            @input="startMenu = false"
                                        />
                                    </v-menu>
                                </b-col>

								<b-col cols="12" md="4">
                                    <v-menu
                                        v-model="endMenu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="filters.endDate"
                                                :label="lang.nd_end_date"
                                                prepend-inner-icon="mdi-calendar"
                                                outlined
                                                dense
                                                readonly
                                                hide-details
                                                v-bind="attrs"
                                                v-on="on"
                                            />
                                        </template>
                                        <v-date-picker
                                            v-model="filters.endDate"
                                            no-title
                                            @input="endMenu = false"
                                        />
                                    </v-menu>
                                </b-col>

                                <b-col cols="12" md="4">
                                    <v-btn
                                        color="primary"
                                        block
                                        large
                                        class="search-btn"
                                        :loading="loading"
                                        @click="fetchDashboardData"
                                    >
                                        <v-icon left>mdi-magnify</v-icon>
                                        {{ lang.nd_search }}
                                    </v-btn>
                                </b-col>
                            </b-row>
                        </v-card-text>
                    </v-card>
                </b-col>
            </b-row>

            <b-row class="mt-3">
				<b-col cols="12" class="text-end mb-2">
					<v-btn
						color="primary"
						outlined
						@click="toggleFullPage"
					>
						{{ showHeader ? lang.nd_full_page : lang.nd_back }}
					</v-btn>
				</b-col>
                <b-col cols="12">
                    <div class="tab-toggle-wrap">
                        <button
                            v-for="tab in permittedTabs"
                            :key="tab.value"
                            type="button"
                            class="tab-toggle"
                            :class="{ 'tab-toggle--active': activeTab === tab.value }"
                            @click="activeTab = tab.value"
                        >
                            <v-icon small class="mr-2">{{ tab.icon }}</v-icon>
                            {{ lang[tab.labelKey] || tab.labelKey }}
                        </button>
                    </div>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col cols="12">
                    <v-card outlined class="content-card">
                        <v-card-text>
							<div v-if="activeTab === 'calendar_dashboard'" class="module-slot">
								<calendar-dashboard-module-content
									ref="calendarDashboardModule"
									:filters="filters"
									:branch-options="branchOptions"
								/>
							</div>

							<div v-else-if="activeTab === 'finance' && canViewFinance" class="module-slot">
                                <finance-module-content
                                    ref="financeModule"
                                    :filters="filters"
                                    :branch-options="branchOptions"
                                />
                            </div>

                            <div v-else-if="activeTab === 'job_cards'" class="module-slot">
                                <job-card-module-content
                                    ref="jobCardsModule"
                                    :filters="filters"
                                    :branch-options="branchOptions"
                                />
                            </div>

                            <div v-else class="module-slot">
                                <work-order-kpi-module-content
                                    ref="workOrdersModule"
                                    :filters="filters"
                                    :branch-options="branchOptions"
                                />
                            </div>
                        </v-card-text>
                    </v-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
	
</template>

<script>
import axios from 'axios';
import CalendarDashboardModuleContent from './CalendarDashboardModuleContent.vue';
import FinanceModuleContent from './FinanceModuleContent.vue';
import JobCardModuleContent from './JobCardModuleContent.vue';
import WorkOrderKpiModuleContent from './WorkOrderKpiModuleContent.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue';
import TabsComp from '@/components/tabsComp.vue';

export default {
	name: 'NewDashboard',
	components: {
		TabsComp,
		CalendarDashboardModuleContent,
		FinanceModuleContent,
		JobCardModuleContent,
		WorkOrderKpiModuleContent,
        HeaderPortrate
	},
	data() {
		const today = new Date();
		const localDate = date => `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
		return {
            showHeader: true,
			loading: false,
			startMenu: false,
			endMenu: false,
			activeTab: 'calendar_dashboard',
			tabs: [
				{ labelKey: 'nd_calendar_dashboard', value: 'calendar_dashboard', icon: 'mdi-calendar-month-outline' },
				{ labelKey: 'nd_finance_module', value: 'finance', icon: 'mdi-cash-multiple' },
				{ labelKey: 'nd_job_cards', value: 'job_cards', icon: 'mdi-clipboard-text-outline' },
				{ labelKey: 'nd_work_orders', value: 'work_orders', icon: 'mdi-briefcase-outline' }
			],
			filters: {
				startDate: localDate(new Date(today.getFullYear(), today.getMonth(), 1)),
				endDate: localDate(today),
				branches: []
			},
			branchOptions: [],
			defaultBranchId: 0
		};
	},
	mounted() {
		this.fetchBranches();
	},
	computed: {
        canViewFinance() {
            return [1,2].includes(Number(this.$store.getters.state.group_id));
        },
        permittedTabs() {
            return this.tabs.filter(tab => tab.value !== 'finance' || this.canViewFinance);
        },
		lang: function () {
			if (this.$cookies.get(this.$store.state.LangCooki) != null) {
				if (this.$cookies.get(this.$store.state.LangCooki) == 'en') {
					return this.$store.state.lang.en;
				} else if (this.$cookies.get(this.$store.state.LangCooki) == 'ur') {
					return this.$store.state.lang.ur;
				} else {
					return this.$store.state.lang.ar;
				}
			}
			else if (this.$store.state.deflang == 'en') {
				return this.$store.state.lang.en;
			}
			else if (this.$store.state.deflang == 'ur') {
				return this.$store.state.lang.ur;
			} else {
				return this.$store.state.lang.ar;
			}
		},
		showBranchButtons() {
			return this.branchOptions.length > 1;
		}
	},
	methods: {
		toggleBranch(branchId) {
			if (!this.showBranchButtons) {
				return;
			}

			const id = Number(branchId || 0);
			if (id <= 0) {
				return;
			}

			const selected = Array.isArray(this.filters.branches) ? [...this.filters.branches] : [];
			const currentIndex = selected.indexOf(id);

			if (currentIndex === -1) {
				selected.push(id);
			} else {
				selected.splice(currentIndex, 1);
			}

			this.filters.branches = selected;
		},
		toggleFullPage() {
			this.showHeader = !this.showHeader;
		},
		dashboardApiPath() {
			const base =
				this.$store &&
				this.$store.state &&
				this.$store.state.SAMCOTEC &&
				this.$store.state.SAMCOTEC.r_path
					? this.$store.state.SAMCOTEC.r_path
					: '';
			if (base && base.indexOf('index.php') !== -1) {
				return base.replace('index.php', 'new-dashboard.php');
			}
			if (base && base.endsWith('/')) {
				return `${base}new-dashboard.php`;
			}
			return 'api/new-dashboard.php';
		},
		fetchBranches() {
			const post = new FormData();
			post.append('module', 'branches');

			axios.post(this.dashboardApiPath(), post)
				.then((response) => {
					const payload = response && response.data ? response.data : {};
					const branches = payload && payload.data && Array.isArray(payload.data.branches)
						? payload.data.branches
						: [];
					const defaultBranchId = Number(payload && payload.data ? (payload.data.defaultBranchId || 0) : 0);
					this.branchOptions = branches.map((branch) => ({
						id: Number(branch.id || 0),
						name: branch.name || this.lang.nd_unknown_branch
					})).filter((branch) => branch.id > 0);

					this.defaultBranchId = defaultBranchId;

					if (this.branchOptions.length === 1) {
						this.filters.branches = [this.branchOptions[0].id];
						return;
					}

					this.filters.branches = this.branchOptions.map((branch) => branch.id);
				})
				.catch(() => {
					this.branchOptions = [];
					this.defaultBranchId = 0;
				});
		},
		fetchDashboardData() {
			const params = {
				module: this.activeTab,
				startDate: this.filters.startDate,
				endDate: this.filters.endDate,
				branchIds: this.filters.branches,
				timeGrain: this.resolveTimeGrain()
			};

			this.loading = true;

			let request = Promise.resolve();
			if (this.activeTab === 'calendar_dashboard' && this.$refs.calendarDashboardModule && typeof this.$refs.calendarDashboardModule.fetchCalendarData === 'function') {
				request = this.$refs.calendarDashboardModule.fetchCalendarData();
			} else if (this.activeTab === 'finance' && this.$refs.financeModule && typeof this.$refs.financeModule.fetchIncomeData === 'function') {
				request = this.$refs.financeModule.fetchIncomeData();
			} else if (this.activeTab === 'job_cards' && this.$refs.jobCardsModule && typeof this.$refs.jobCardsModule.fetchJobCardsData === 'function') {
				request = this.$refs.jobCardsModule.fetchJobCardsData();
			} else if (this.activeTab === 'work_orders' && this.$refs.workOrdersModule) {
				request = this.$refs.workOrdersModule.fetchWorkOrderData();
			}

			Promise.resolve(request)
				.catch(() => null)
				.finally(() => {
					this.loading = false;
					// eslint-disable-next-line no-console
					console.log('Dashboard search payload:', params);
				});
		},
		resolveTimeGrain() {
			const now = new Date();
			const end = this.parseISODate(this.filters.endDate) || now;
			const start = this.parseISODate(this.filters.startDate) || new Date(end.getFullYear(), end.getMonth(), 1);
			const normalizedStart = start <= end ? start : end;
			const normalizedEnd = start <= end ? end : start;

			const oneDay = 1000 * 60 * 60 * 24;
			const daysDiff = Math.floor((normalizedEnd - normalizedStart) / oneDay);
			const monthSpan =
				(normalizedEnd.getFullYear() - normalizedStart.getFullYear()) * 12 +
				(normalizedEnd.getMonth() - normalizedStart.getMonth());

			if (monthSpan >= 1 || daysDiff > 31) {
				return 'monthly';
			}

			if (this.isSameWeek(normalizedStart, normalizedEnd)) {
				return 'daily';
			}

			return 'weekly';
		},
		parseISODate(value) {
			if (!value) return null;
			const [year, month, day] = value.split('-').map(Number);
			if (!year || !month || !day) return null;
			return new Date(year, month - 1, day);
		},
		isSameWeek(start, end) {
			const startOfWeek = (date) => {
				const copy = new Date(date);
				const day = copy.getDay();
				const diff = day === 0 ? -6 : 1 - day;
				copy.setDate(copy.getDate() + diff);
				copy.setHours(0, 0, 0, 0);
				return copy;
			};

			return startOfWeek(start).getTime() === startOfWeek(end).getTime();
		}
	}
};
</script>

<style scoped>
.new-dashboard {
	background: #f5f7fa;
	min-height: 100%;
}

.filter-card,
.content-card {
	border-color: #e3e8ef !important;
	background: #ffffff;
}

.search-btn {
	font-weight: 600;
	letter-spacing: 0.2px;
}

.branch-buttons-wrap {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	min-height: 40px;
	align-items: center;
	justify-content: center;
	margin-top: 8px;
	margin-bottom: 8px;
}

.branch-btn {
	display: inline-flex;
	align-items: center;
	border-radius: 8px;
	padding: 7px 12px;
	font-size: 0.86rem;
	font-weight: 600;
	border: 1px solid #d7dde5;
	background: #fff;
	color: #4a5568;
	transition: all 0.2s ease;
}

.branch-btn--active {
	color: #fff;
	box-shadow: 0 4px 10px rgba(15, 23, 42, 0.14);
}

.branch-btn--c0.branch-btn--active { background: #1d4ed8; border-color: #1d4ed8; }
.branch-btn--c1.branch-btn--active { background: #047857; border-color: #047857; }
.branch-btn--c2.branch-btn--active { background: #b45309; border-color: #b45309; }
.branch-btn--c3.branch-btn--active { background: #7c3aed; border-color: #7c3aed; }
.branch-btn--c4.branch-btn--active { background: #be123c; border-color: #be123c; }
.branch-btn--c5.branch-btn--active { background: #0f766e; border-color: #0f766e; }

.tab-toggle-wrap {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}

.tab-toggle {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border: 1px solid #d7dde5;
	border-bottom: 2px solid transparent;
	border-radius: 8px;
	padding: 10px 16px;
	background: #ffffff;
	color: #4a5568;
	font-size: 0.92rem;
	font-weight: 600;
	transition: all 0.2s ease;
}

.tab-toggle:hover {
	border-color: #b8c2cf;
	color: #2d3748;
}

.tab-toggle--active {
	color: #1976d2;
	border-color: #bbdefb;
	border-bottom-color: #1976d2;
	box-shadow: 0 4px 12px rgba(25, 118, 210, 0.12);
}

.module-slot {
	min-height: 260px;
	border: 1px dashed #d3dae5;
	border-radius: 8px;
	padding: 20px;
	background: #fcfdff;
}

.module-title {
	margin-bottom: 8px;
	font-size: 1rem;
	font-weight: 700;
	color: #2d3748;
}

.module-text {
	color: #6b7280;
}
</style>
